import React from "react";
import Header from "./components/General/Header";
import OtpComp from "./components/General/Otp.component";

const Otp = () => {
  return (
    <>
      <Header />
      <OtpComp />
    </>
  );
};

export default Otp;
